import api from '../../../services/api';

/**
 * Service for handling global communication notifications.
 * These notifications include RFP assignments, status updates, and chat mentions.
 */
const NOTIF_BASE = '/communication/v1/notifications';

export const listNotifications = async (params = {}) => {
    return api.get(NOTIF_BASE, { params });
};

export const getUnreadNotificationCount = async () => {
    return api.get(`${NOTIF_BASE}/unread-count`);
};


export const markNotificationAsRead = async (notificationId) => {
    return api.post(`${NOTIF_BASE}/mark-read`, { notification_ids: [notificationId] });
};

export const markAllNotificationsAsRead = async () => {
    return api.post(`${NOTIF_BASE}/mark-read`, { notification_ids: [] });
};

